import { Observable, of } from 'rxjs';
import { Destroyable, IDestroyable, keyValueDiffers } from '../../../common';

export interface IConfigSourceOptionWrapper {
  id: string; // 图表id
  classID: string; // 图表类型id
  configSourceOption: any;
}

export interface IConfigSourceFactory extends IDestroyable {
  getConfigSource(configSourceOptionWrapper: IConfigSourceOptionWrapper): Observable<any>;
}

/**
 * 配置源工厂
 */
// @dynamic
export class DefaultConfigSourceFactory extends Destroyable implements IConfigSourceFactory {
  private static _configSourceFactory: IConfigSourceFactory;

  static getInstance() {
    if (!this._configSourceFactory) {
      this._configSourceFactory = new DefaultConfigSourceFactory();

    }
    return this._configSourceFactory;
  }

  private constructor() {
    super();
  }

  getConfigSource(configSourceOptionWrapper: IConfigSourceOptionWrapper): Observable<any> {
    const
      option = configSourceOptionWrapper.configSourceOption,
      changes = keyValueDiffers.find({}).create().diff(option),
      array = [];
    if (changes) {
      changes.forEachRemovedItem((record) => {
        array.push({
          key: `remove.${record.key}`,
          oldValue: record.previousValue,
          newValue: record.currentValue,
          option,
        });
      });
      changes.forEachAddedItem((record) => {
        array.push({
          key: `add.${record.key}`,
          oldValue: record.previousValue,
          newValue: record.currentValue,
          option,
        });
      });
      changes.forEachChangedItem((record) => {
        array.push({
          key: record.key,
          oldValue: record.previousValue,
          newValue: record.currentValue,
          option,
        });
      });
    }

    array.push({
      key: 'option',
      oldValue: option,
      newValue: option,
      option,
    });

    return of(array);
  }
}


